import { Injectable } from '@angular/core';
import { FunctionsService } from '../__common/functions.service';

@Injectable({
  providedIn: 'root'
})
export class MinutaService {

  constructor(private commonFunctions: FunctionsService) { }

  toLowerCaseObj(field){
    return field.toLowerCase();
  }

  generatePresentText(client: any): string {
    let presentText = `Actualmente, ${client.name}`;

    if(client.age && client.age != 0) {
      presentText += `, de ${client.age} años`;
    }

    /* presentText += `, reside en ${client.address || 'su dirección actual'}.`;
    */
   
    if (client.career) {
      presentText += ` ejerce como ${client.career}`;
    }

    if (client.studyHistory) {
      if (client.studyHistory == 'finished') {
        presentText += `, y ya ha finalizado sus estudios.`;
      }

      if (client.studyHistory == 'progress') {
        presentText += `, y actualmente está cursando sus estudios en ${client.currentStudies}.`;      
      }
    }

    /* Como nos conoció */
    if (client.how) {
      presentText += ` Nos conoció vía ${this.toLowerCaseObj(client.how)}.`;
    }

    /* Ya ha iniciado la búsqueda de estudios */
    if (client.studySearch == 'yes') {
      if (client.studyConfirmation == '1') {
        presentText += `Ya ha elegido la Universidad y plan de estudios, y cuenta con la confirmación.`;
      }else{
        presentText += `Ya ha comenzado con la búsqueda de Universidad y plan de estudios.`;
      }
    }else{
      presentText += `Por el momento no ha comenzado con la búsqueda de Universidad/plan de estudios.`;      
    }

    if (client.usVisa || client.uePassport) {
      presentText += '. Posee';
      let visas = [];
      if (client.hasStudentVisa == '1') visas.push('visa de estudiante');
      if (client.usVisa == 'yes') visas.push('visa estadounidense');
      if (client.uePassport == 'yes') visas.push('pasaporte europeo');
      presentText += ` ${visas.join(', ')}`;
    }

    if (client.hasStudentVisa){
      if(client.hasStudentVisa == '1'){
        presentText += `Cuenta con el visado de estudios aprobado.`;
      }
      if(client.hasStudentVisa == '0'){
        presentText += `Todavía no cuenta con el visado de estudios.`;

      }
    }

    if(client.validPassport){
      client.validPassport = true? presentText += `El pasaporte está vigente y con margen de fecha de vencimiento.` : presentText += `Es necesario renovar el pasaporte previo a la solicitud del visado.`
    }

    /* Ha estado en europa */
    if (client.atEurope) {
      if (client.atEurope == 'yes') {
        presentText += `Ya ha estado en Europa en el pasado.`;
        if(client.visitedCountries){
          presentText += `En específico ha visitado ${client.visitedCountries}.`;
        }
      }
      if (client.atEurope == 'no') {
        presentText += `Esta será la primera vez que viaja por Europa.`;      
      }
    }
    return presentText;
  }

  generateGoalText(client: any){
    let goalText;
    if(client['goal']){
      if(client['studyDescription']){
        goalText = 'El objetivo planteado por '+ client['name'] + ' es '+ client['goal'].toLowerCase() + ', en específico '+ client['studyDescription'];
      }else{
        goalText = 'El objetivo planteado por '+ client['name'] + ' es '+ client['goal'].toLowerCase() + '.';
      }
    }else{
      if(client['studyDescription']){
        goalText = 'El objetivo planteado por '+ client['name'] + ' es ' + client['studyDescription'];
      }else{
        goalText = '';
      }
    }
    return goalText;
  }

  generateFutureText(client: any): string {

    let futureText= '';

    if (client.university) {
      futureText += `Su universidad/centro de estudios de destino será ${client.university} `;
    }
    if(!this.commonFunctions.isDateEmpty(client.startLessons)){
      futureText +=  `y comenzará sus estudios en ${this.commonFunctions.getShortDate(client.startLessons)} (${client.startLessons})`;
    }else{
      futureText +=  `sin fecha de inicio de estudios definida por el momento`;
    }

    if (client.tuitionPaid == "1") {
      futureText += `, donde ya ha realizado los pagos de matrícula.`;
    }else{
      futureText += `donde aún están pendientes los pagos respectivos.`;
    }

    //Start Date - Llegada a la ciudad
    if (!this.commonFunctions.isDateEmpty(client.dateFrom)) {
      futureText +=  `La fecha de llegada sería aproximadamente en ${this.commonFunctions.getShortDate(client.dateFrom)}`;    
    }else{
      futureText +=  `La fecha de llegada se definirá posteriormente.`;
    }

    // Include additional future planning details if available
    if ((client.apartmentType !=  "") || (client.apartmentBudget>0)) {
      futureText += ' En cuanto a alojamiento, busca ';
      if (client.apartmentType) {
        futureText += `un ${client.apartmentType}`;
      }
      if (client.apartmentBudget>0) {
        futureText += ` con un presupuesto de ${client.apartmentBudget}`;
      }
      futureText += '.';
    }

    return futureText;

      /*     <span ngIf="getClientDataObj().payments">Los gastos asociados se cubrirán mediante {{ getClientDataObj().payments }}</span>
                                      <span ngIf="!getClientDataObj().payments">La forma de afrontar los gastos asociados al viaje y al día a día en la ciudad elegida se definirá posteriormente. </span>
                                 
                                      <span ngIf="getFieldValue('apartmentType') == 'shared'"> No le importaría vivir sol@ o con roommates al inicio por facilidad en la gestión del contrato de alquiler y demás servicios. </span>
                                      <span ngIf="getFieldValue('apartmentType') == 'private'"> Le gustaría vivir en un piso privado. </span>
                                      <span ngIf="getFieldValue('apartmentType') == 'none'">Respecto a la búsqueda de piso, el mismo puede ser compartido o privado.  </span>
                                      <span ngIf="getFieldValue('privateBathroom') == 'shared'">El baño puede ser compartido. </span>
                                      <span ngIf="getFieldValue('privateBathroom') == 'private'">Idealmente intentar buscar un piso con baño privado.  </span>
                                      <span ngIf="getFieldValue('privateBathroom') == 'none'">Es indiferente si el baño es privado o compartido. </span>
                                      <span ngIf="getFieldValue('budget') != null">El presupuesto disponible serían unos {{getFieldValue('budget')}} Euros. */
  }
}

    /* .studyChoice
    Los estudios a realizar serán: {{getClientDataObj().studyChoice}}</span> -->
                                
    
    Podríamos ponerle en contacto con otros ticos que estén en la misma situación o parecida para facilitar el proceso de adaptación.
 */
    /* Por resolver  
    Buscar opciones de Masters en diferentes Universidades de España para realizar una comparación y un análisis de cuál será la 
    mejor opción para lo que está buscando. 
  
    El importe de la matrícula ya fue pagado, al inicio de clases se pagará el monto faltante.
 */
/*     Le gustaría vivir con roommates al inicio por facilidad en la gestión del contrato de alquiler y demás servicios. 
    Su presupuesto sería de unos 400 EUR para encontrar una buena habitación en un lugar agradable, le han recomendado la zona de Chamberí. 
    
    Renovación del pasaporte y revisión de la fecha de vencimiento de la VISA de USA, en caso de que decida viajar haciendo escala. 
 */
